module.exports = __webpack_public_path__ + "static/media/Red-White.35e5d655.png";